import React, { useContext, useEffect, useState } from 'react';

import styles from "../DashboardFileManagement/DashboardFileManagement.module.css"

import bedIcon from "../../../assets/img/DashboardICons/bedIcon.svg"
import meterIcon from "../../../assets/img/DashboardICons/meterIcon.svg"
import buildingIcon from "../../../assets/img/DashboardICons/buildingIcon.svg"
import locationIcon from "../../../assets/img/DashboardICons/locationIcon.svg"
import calenderIcon from "../../../assets/img/DashboardICons/CalenderIcon.svg"
import axios from 'axios';
import { UserContext } from '../../Context/UserContextProvider';

export default function FileHouseDetail({ cardDetailData, limit }) {
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    const { userToken, userData, permissions } = useContext(UserContext);

    let [categories, setCategories] = useState([]);

    

    useEffect(() => {
        axios.get("Category", {
            headers: {
                authorization: "Bearer " + userToken
            }
        }).then((res) => {
            setCategories(res.data?.data || []);
        });
    }, []);

    const shopCategories = [304, 280]
    const hotelCategories = [278, 291]
    const gasStationCategories = [309, 316]
    const landCategories = [273, 277, 281, 284, 287, 302, 305, 308, 312, 315, 517];

    function getCategoryParent(){
        let selectedCategory = categories.find(c => c.id == cardDetailData.categoryId);

        return selectedCategory?.parentId;
    }

    function getShopFields(){
        return <>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ کف مغازه</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterageBase)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ دهنه</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterageGate)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ بالکن</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterageBalkony)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>انبار تجاری</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.commercialStorage)}
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>ارتفاع سقف</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.ceilingHeight)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={calenderIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>سال ساخت</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.constructionYear?.toString())}
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{height: "20px", width: "20px", filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);"}}><path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"/></svg>
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>تعداد طبقه</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.totalFloors)}
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{height: "20px", width: "20px", filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);"}}><path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"/></svg>
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}> طبقه</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.floors)}
                    </span>
                </div>
            </div>
        </>
        
    }

    function getHotelFields(){
        return <>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ بنا</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterageBase)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ زمین</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterage)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={calenderIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>سال ساخت</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.constructionYear?.toString())}
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{height: "20px", width: "20px", filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);"}}><path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"/></svg>
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>تعداد طبقه</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.totalFloors)}
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{height: "20px", width: "20px", filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);"}}><path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"/></svg>
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}> طبقه</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.floors)}
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={bedIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>تعداد اتاق</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.roomCount)}
                    </span>
                </div>
            </div>
        </>
    }

    function getGasStationFields(){
        return <>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ بنا</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterageBase)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ زمین</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterage)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={calenderIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>سال ساخت</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.constructionYear?.toString())}
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={calenderIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>تعداد نازل</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.pumpCount)}
                    </span>
                </div>
            </div>
        </>
    }

    function getLandFields(){
        return <>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ بنا</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterageBase)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>متراژ زمین</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.meterage)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>عرض گذر</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.walkawayWidth)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>عرض ملک</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.landWidth)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={meterIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>طول ملک</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.landHeight)} متر
                    </span>
                </div>
            </div>
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                    <img src={calenderIcon} alt="icon" />
                </div>
                <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                    <span className={styles.card_main_detail_text1}>سال ساخت</span>
                    <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                        {e2p(cardDetailData?.constructionYear?.toString())}
                    </span>
                </div>
            </div>
        </>
    }

    return (
        <>
            <div className='w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-2 px-3'>
                <hr className="solid w-100" />
                <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mt-2 mb-2 px-3' style={{gap: "10px"}}>
                    {
                        shopCategories.includes(getCategoryParent())? getShopFields() : hotelCategories.includes(getCategoryParent())? getHotelFields() : gasStationCategories.includes(getCategoryParent())? getGasStationFields() : landCategories.includes(getCategoryParent())? getLandFields() : <></>
                    }
                    {limit?.find((item) => item === "RoomCount") || shopCategories.includes(getCategoryParent()) || shopCategories.includes(getCategoryParent()) || hotelCategories.includes(getCategoryParent()) || gasStationCategories.includes(getCategoryParent()) || landCategories.includes(getCategoryParent()) ?
                        <></> : <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                            <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                                <img src={bedIcon} alt="icon" />
                            </div>
                            <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                                <span className={styles.card_main_detail_text1}>تعداد اتاق</span>
                                <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                                    {e2p(cardDetailData?.roomCount?.toString())} خوابه
                                </span>
                            </div>
                        </div>}

                    {limit?.find((item) => item === "Meterage") || shopCategories.includes(getCategoryParent()) || hotelCategories.includes(getCategoryParent()) || gasStationCategories.includes(getCategoryParent()) || landCategories.includes(getCategoryParent()) ?
                        <></> : <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                            <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                                <img src={meterIcon} alt="icon" />
                            </div>
                            <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                                <span className={styles.card_main_detail_text1}>متراژ کل</span>
                                <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                                    {e2p(cardDetailData?.meterage?.toString())} متر
                                </span>
                            </div>
                        </div>}

                        {limit?.find((item) => item === "Floor") || shopCategories.includes(getCategoryParent()) || hotelCategories.includes(getCategoryParent()) || gasStationCategories.includes(getCategoryParent()) || landCategories.includes(getCategoryParent()) ?
                        <></> : <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                            <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                                <img src={buildingIcon} alt="icon" />
                            </div>
                            <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                                <span className={styles.card_main_detail_text1}>طبقه</span>
                                <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                                    {cardDetailData?.floor == "0" ?
                                        "همکف" :
                                        cardDetailData?.floor == "-1" ?
                                            "زیرزمین"
                                            :
                                            e2p(cardDetailData?.floor?.toString())
                                    }
                                </span>
                            </div>
                        </div>}

                        {limit?.find((item) => item === "Floor") || shopCategories.includes(getCategoryParent()) || hotelCategories.includes(getCategoryParent()) || gasStationCategories.includes(getCategoryParent()) || landCategories.includes(getCategoryParent()) ?
                        <></> : <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                            <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                                <img src={buildingIcon} alt="icon" />
                            </div>
                            <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                                <span className={styles.card_main_detail_text1}>تعداد طبقه</span>
                                <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                                    {e2p(cardDetailData?.totalFloors)}
                                </span>
                            </div>
                        </div>}

                    {limit?.find((item) => item === "ConstructionYear") || shopCategories.includes(getCategoryParent()) || hotelCategories.includes(getCategoryParent()) || gasStationCategories.includes(getCategoryParent()) || landCategories.includes(getCategoryParent()) ?
                        <></> : <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                            <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                                <img src={calenderIcon} alt="icon" />
                            </div>
                            <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                                <span className={styles.card_main_detail_text1}>سال ساخت</span>
                                <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                                    {e2p(cardDetailData?.constructionYear?.toString())}
                                </span>
                            </div>
                        </div>}

                    <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                        <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                            <img src={locationIcon} alt="icon" />
                        </div>
                        <div className='d-flex align-items-start justify-content-center flex-column me-3'>
                            <span className={styles.card_main_detail_text1}>منطقه</span>
                            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>
                                {e2p(cardDetailData?.address.zone?.toString())}
                            </span>
                        </div>
                    </div>
                </div>
                <hr className="solid w-100" />
            </div>
        </>
    )
}
